import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  root: {},

  shareIcons: {
    justifyContent: "space-around",
    display: "flex",
    maxWidth: "350px",
    margin: "auto"
  },
  shareLink: {
    padding: "0.5rem 1rem",
    border: `1px solid ${theme.palette.primary.main}`,
    display: "flex",
    color: theme.palette.primary.main,
    justifyContent: "space-between",
    borderRadius: "5px",
    backgroundColor: "#E8EFFD",
    whiteSpace: "normal",
    alignItems: "center",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      padding: "0.5rem",
    },
  },
  copy: {
    [theme.breakpoints.up("md")]: {
      borderLeft: "2px solid #BAC2C9",
      padding: "0 1rem",
    },
  },
  referLink: {
    fontSize: "14px",
    fontWeight: "bold",
  },
  title: {
    fontWeight: "600",
  },
}))

export { useStyles }
